import React, { useEffect } from "react";

import { Loading, UploadProgressBanner } from "components";

import { useAuthentication } from "hooks";

import { AuthenticatedRouter } from "./authenticated";
import { UnauthenticatedRouter } from "./unauthenticated";

export const Root = () => {
  const { isUserAuthenticated, isLoading } = useAuthentication();

  useEffect(() => {
    window.sessionStorage.setItem(
      "navigator_language",
      JSON.stringify(navigator.language),
    );
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  if (isUserAuthenticated) {
    return (
      <>
        <UploadProgressBanner />
        <AuthenticatedRouter />
      </>
    );
  }

  return (
    <>
      <UploadProgressBanner />
      <UnauthenticatedRouter />
    </>
  );
};
